
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';

@Component
export default class PageLoader extends Vue {
	@Prop({ type: Boolean, required: true })
	public isShown!: boolean;
}
